import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import {
  ToastComponent,
  ConfirmpopupComponent,
  AlertPopupComponent,
  GlobalLoader,
} from './shared/components';
import { Resizewindow } from './shared/directives/resizewindow';
import { HeaderService } from './shared/services/headerService';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ToastComponent,
    AlertPopupComponent,
    ConfirmpopupComponent,
    Resizewindow,
    GlobalLoader,
  ],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private readonly header = inject(HeaderService);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly title = signal('AI Agent');
  readonly getLoaderVisible = signal(true);
  /**
   * Start as `blank` so we do not render the main shell (sidebar + recent chats) before the
   * router resolves. Otherwise Recent Chats calls protected APIs before session links run.
   */
  readonly layouttemplate = signal<'blank' | ''>('blank');

  ngOnInit(): void {
    this.header
      .getLoaderVisibility()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((visible) => {
        this.getLoaderVisible.set(visible);
      });
    this.applyLayoutFromRoute();
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.applyLayoutFromRoute());
  }

  private applyLayoutFromRoute(): void {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const layout = route.snapshot.data['layout'];
    this.layouttemplate.set(layout === 'blank' ? 'blank' : '');
  }
}
